<template>
  <div class="navi">
    <div class="logo"></div>
    <div @click="toggleMenu" :class="menuClass" class="menu"></div>
    <ul v-if="opened" class="menu-list">
      <li
        v-for="item in menus"
        @click="handleClickMenuItem(item)"
        :key="item"
        :class="item"
        class="menu-list-item"
      ></li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      opened: false,
      menus: ['concept', 'business', 'company', 'contact']
    }
  },

  computed: {
    menuClass() {
      return {
        active: this.opened
      }
    }
  },

  methods: {
    toggleMenu() {
      this.opened = !this.opened
    },
    handleClickMenuItem(pageName) {
      this.opened = false
      this.$store.commit('setPage', pageName)
    }
  }
}
</script>

<style lang="sass" scoped>
.navi
  .logo
    z-index: 1000
    width: 55px
    height: 44px
    background-image: url('/images/sp/logo.svg')
    background-repeat: no-repeat
    background-position: center
    position: fixed
    top: 14px
    left: 20px
  .menu
    z-index: 1000
    cursor: pointer
    width: 30px
    height: 32px
    background-image: url('/images/sp/menu.svg')
    background-repeat: no-repeat
    background-position: center bottom
    position: fixed
    top: 20px
    right: 20px
    &.active
      background-image: url('/images/sp/menu-active.svg')

  .menu-list
    z-index: 500
    position: fixed
    top: 0
    left: 0
    width: 100%
    height: 100%
    margin: 0
    padding: 0
    padding-top: 160px
    background-color: #F0F0EB
    &-item
      width: 236px
      height: 52px
      margin: 0 auto
      margin-bottom: 40px
      background-repeat: no-repeat
      background-position: center
      background-position: left center
      list-style: none
      @each $page in concept, business, company, contact
        &.#{$page}
          background-image: url('/images/sp/menu/menu-#{$page}.svg')
</style>
